export const filterByFields = [
    {
        fieldsName: 'cae',
        description: 'Артикул',
        id: 'field_cae',
        order: 0,
        city: null,
    },
    {
        fieldsName: 'name',
        description: 'Наименование',
        id: 'field_name',
        order: 1,
        city: null,
    },
    {
        fieldsName: 'price_opt',
        description: 'Цена V.I.P.',
        id: 'field_price_opt',
        order: 2,
        city: null,
    },
    {
        fieldsName: 'price_mrc',
        description: 'Цена МРЦ',
        id: 'field_price_mrc_main',
        order: 3,
        city: null,
    },
    {
        fieldsName: 'price_margin',
        description: 'Цена',
        id: 'field_price_margin',
        order: 4,
        city: null,
    },
    {
        fieldsName: 'brand',
        description: 'Бренд',
        id: 'sorted_brand',
        order: 5,
        city: null,
    },
    {
        fieldsName: 'stock_krd_main',
        description: 'Остаток главный склад',
        id: 'field_stock_krd_main',
        order: 6,
        city: 'krasnodar',
    },
    {
        fieldsName: 'stock_stavropol',
        description: 'Остаток Ставрополь',
        id: 'field_stock_stavropol',
        order: 7,
        city: 'stavropol',
    },
    {
        fieldsName: 'stock_crimea',
        description: 'Остаток Крым',
        id: 'field_stock_crimea',
        order: 8,
        city: 'crimea',
    },
    {
        fieldsName: 'stock_voronezh',
        description: 'Остаток Воронеж',
        id: 'field_stock_voronezh',
        order: 9,
        city: 'voronezh',
    },
];

export const formats = [
    {
        fieldsName: 'XML',
        id: 'xml',
    },
    {
        fieldsName: 'Excel',
        id: 'excel',
    },
    {
        fieldsName: 'CSV',
        id: 'csv',
    },
    {
        fieldsName: 'JSON',
        id: 'json',
    },
];

export const storageCities = [
    {
        fieldsName: 'Краснодар',
        id: 'krasnodar',
    },
    {
        fieldsName: 'Ставрополь',
        id: 'stavropol',
    },
    {
        fieldsName: 'Крым',
        id: 'crimea',
    },
    {
        fieldsName: 'Воронеж',
        id: 'voronezh',
    },
];

export const products = [
    {
        fieldsName: 'Шины',
        id: 'tyres',
    },
    {
        fieldsName: 'Диски',
        id: 'rims',
    },
    {
        fieldsName: 'Грузовая шина',
        id: 'truck_tyres',
    },
    {
        fieldsName: 'Мотошина',
        id: 'moto_tyres',
    },
    {
        fieldsName: 'Индустриальная шина',
        id: 'industrial_tyres',
    },
    {
        fieldsName: 'Паста Ш/М',
        id: 'tire_paste',
    },
    {
        fieldsName: 'Гайки',
        id: 'nuts',
    },
    {
        fieldsName: 'Болты',
        id: 'bolts',
    },
    {
        fieldsName: 'Датчики давления',
        id: 'sensors',
    },
    {
        fieldsName: 'Груза',
        id: 'burden',
    },
    {
        fieldsName: 'Проставочные кольца',
        id: 'rings',
    },
    {
        fieldsName: 'Латки',
        id: 'patches',
    },
    {
        fieldsName: 'Вентили',
        id: 'valves',
    },
    {
        fieldsName: 'Камеры',
        id: 'cameras',
    },
    {
        fieldsName: 'Ободные ленты',
        id: 'rim_tapes',
    },
    {
        fieldsName: 'Пакеты',
        id: 'packs',
    },
    {
        fieldsName: 'Химия',
        id: 'chemicals',
    },
    {
        fieldsName: 'Рабочая одежда',
        id: 'workwear',
    },
    {
        fieldsName: 'Ботинки',
        id: 'shoes',
    },
    {
        fieldsName: 'Инструменты',
        id: 'tools',
    },
    {
        fieldsName: 'Смазки',
        id: 'lubricant',
    },
    {
        fieldsName: 'Масла',
        id: 'oil',
    },
    {
        fieldsName: 'Тормозные колодки',
        id: 'brake_pads',
    },
    {
        fieldsName: 'Тормозные диски',
        id: 'brake_disc',
    },
    {
        fieldsName: 'Датчик тормозные колодок',
        id: 'brake_sensor',
    },
    {
        fieldsName: 'Фильтра',
        id: 'filters',
    },
    {
        fieldsName: 'Расходные материалы',
        id: 'consumables',
    },
    {
        fieldsName: 'Автомобильные принадлежности',
        id: 'accessories',
    }
];


export const sortedByFields = [
    {
        fieldsName: 'brand',
        description: 'Бренд',
        id: 'sorted_brand',
        order: 1,
    },
    {
        fieldsName: 'height',
        description: 'Высота',
        id: 'sorted_height',
        order: 2,
    },
    {
        fieldsName: 'width',
        description: 'Ширина',
        id: 'sorted_width',
        order: 3,
    },
    {
        fieldsName: 'diameter',
        description: 'Диаметр',
        id: 'sorted_diameter',
        order: 4,
    },
];


export const sortedByFieldsNoTyres = [{
    fieldsName: 'brand',
    description: 'Бренд',
    id: 'sorted_brand',
    order: 1,
}]

